import {
  DocumentsDeleteMutationTypes,
} from './mutation_types'
import { DocumentsDeleteState } from './state'

export const mutations: StoreMutations<DocumentsDeleteMutationTypes, DocumentsDeleteState> = {
  [DocumentsDeleteMutationTypes.SET_LOADING] (state, value) {
    state.loading = value
  },
  [DocumentsDeleteMutationTypes.SET_IS_OPEN] (state, value) {
    state.isOpen = value
  },
  [DocumentsDeleteMutationTypes.SET_DOCUMENTS] (state, documents) {
    state.documents = documents
  },
}
